export const RESET_PASSWORD_STEP = {
  Step_1_Before_Email: 1,
  Step_2_After_Email: 2,
};

export const Scenario = {
  NeedsRegistration: 1,
  FirstRegistration: 2,
};



// WEBPACK FOOTER //
// ./src/pages/login/helpers/constants.js